module.exports = __webpack_public_path__ + "static/media/tt_commons_medium-webfont.505d7f98.woff2";